module.exports = __webpack_public_path__ + "static/media/furreEndly.98d5d5c3.jpg";